export default __webpack_public_path__ + "static/media/background_cityscape.93cefc2f.png";